import { render, staticRenderFns } from "./Inclusao.vue?vue&type=template&id=cfbf3e5e"
import script from "./Inclusao.vue?vue&type=script&lang=js"
export * from "./Inclusao.vue?vue&type=script&lang=js"
import style0 from "./Inclusao.vue?vue&type=style&index=0&id=cfbf3e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports